import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Features from '../views/Features.vue'
import { getCookie } from '@/util/cookie'

Vue.use(VueRouter)

const bTerminal = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/features',
    name: 'Features',
    component: Features
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('../views/Download.vue')
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('../views/Cases.vue')
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('../views/Pricing.vue')
  },
  {
    path: '/personal',
    name: 'Personal',
    component: () => import('../views/Personal.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  }
]

const cTerminal = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/cTerminal/index.vue')
  },
  {
    path: '/user/about',
    name: 'UserAbout',
    component: () => import('../views/cTerminal/About.vue')
  },
  {
    path: '/user/contact',
    name: 'UserContact',
    component: () => import('../views/cTerminal/Contact.vue')
  }
]

// 创建路由实例
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: []
})

// 动态设置路由
function setRoutes (isCTerminal) {
  const routes = isCTerminal ? cTerminal : bTerminal

  // 清除现有路由
  router.matcher = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: []
  }).matcher

  // 添加新路由
  routes.forEach(route => {
    router.addRoute(route)
  })

  console.log('Routes updated for:', isCTerminal ? 'C端' : 'B端')
}

// 初始化路由
const isCTerminal = getCookie('status')
console.log('Initial terminal status:', isCTerminal)
setRoutes(isCTerminal === null || isCTerminal === 'true')

// 导出路由实例和设置函数
export { router as default, setRoutes }
